export default __webpack_public_path__ + "static/media/6806 - Obolazul.e3e094c9.jpeg";